
import Vue from 'vue';
import TransactionPerStallionOwnerCard from '@/components/transaction/TransactionPerStallionOwnerCard.vue';

export default Vue.extend({
  name: 'TransactionsPerStallionOwner',
  components: { TransactionPerStallionOwnerCard },
});
